import React from 'react';
import { useTranslation } from 'react-i18next';

import { LinkIcon } from '../icons/ExperienceIcons.jsx';

const SelectedExperienceDetails = ({ experience }) => {
  const { t } = useTranslation();
  if (!experience) return null;

  const logoFitClass =
    experience.company_name === 'Kantech'
      ? 'object-cover bg-white'
      : 'object-contain';

  return (
    <div className="p-6 pt-10 md:p-8 bg-tertiary bg-opacity-50 rounded-lg flex flex-col">
      <div className="flex-grow flex flex-col md:flex-row gap-8 md:gap-12 items-start mb-6">
        <div className="w-full md:w-2/3 flex flex-col">
          <div className="mb-4">
            <h3 className="text-white font-bold text-xl md:text-2xl">
              {experience.url && experience.company_name !== 'Kantech' ? (
                <a
                  href={experience.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                  className="underline hover:text-blue-300 transition-colors
                                    inline-flex items-center group"
                >
                  {t(experience.company_name)}
                  <LinkIcon
                    className="w-4 h-4 inline-block opacity-75
                                    relative top-[2px]
                                    md:top-[3px]
                                    ml-1.5 group-hover:opacity-100 transition-opacity"
                  />
                </a>
              ) : (
                t(experience.company_name)
              )}
            </h3>
            {experience.position && (
              <p className="text-lg text-gray-300 font-medium mt-1">
                {t(experience.position)}
              </p>
            )}
            <p className="text-secondary text-md md:text-lg font-semibold mt-1">
              {t(experience.date)}
            </p>
          </div>
          <p className="text-white text-md md:text-lg leading-relaxed mt-2 mb-4 hidden md:block">
            {t(experience.summary)}
          </p>
        </div>
        {experience.logo && (
          <div className="w-full md:w-1/3 flex items-center justify-center md:justify-end mt-4 md:mt-0">
            <img
              src={`${import.meta.env.BASE_URL}${experience.logo}`}
              alt={`${t(experience.company_name)} logo`}
              className={`w-48 md:w-56 h-auto max-h-32 md:max-h-40 rounded-lg p-1 ${logoFitClass}`}
              loading="lazy"
            />
          </div>
        )}
        <p className="text-white text-md md:text-lg leading-relaxed mt-4 mb-4 w-full md:hidden">
          {t(experience.summary)}
        </p>
      </div>
      <div className="flex flex-wrap gap-2 pt-4 border-t border-gray-700 border-opacity-50 mt-auto">
        {experience.technologies.map((tech, index) => {
          const translatedTech = t(tech, { returnObjects: true });
          const techName =
            typeof translatedTech === 'object'
              ? translatedTech.name
              : translatedTech;

          return (
            <span
              key={`${experience.company_name}-tech-${index}`}
              className="bg-primary text-secondary text-sm font-medium px-3 py-1 rounded-full"
            >
              {techName}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default SelectedExperienceDetails;
